import operators, { Operator, operatorLabel } from './operators'
import { objectOf } from '@/utils/arrayUtils'
import { t } from '@/i18n'

type Expression = {
    property: string
    operator: string
    targetProperty?: string
    targetValue?: any
}

type ConditionBlock = {
    and: Expression[]
}

type Conditions = {
    or: ConditionBlock[]
} | boolean | null | undefined

type CheckOptions = {
    $value?: any
    emptyReturn?: boolean
}

function checkExpression(instance: Record<string, any>, exp: Expression, { $value }: { $value?: any } = {}): boolean {
    const operatorMap = objectOf(operators, 'text', true) as Record<string, Operator>
    const operator = operatorMap[exp.operator]

    const v1 = exp.property == '$value' ? $value : instance[exp.property]
    let v2: any = undefined
    if (!operator.single) {
        v2 = operator.targetProperty
            ? (exp.targetProperty == '$value' ? $value : instance[exp.targetProperty!])
            : exp.targetValue
    }

    return operator.eval(v1, v2)
}

export function checkConditions(instance: Record<string, any>, conditions: Conditions, { $value, emptyReturn = false }: CheckOptions = {}): boolean {
    if (conditions === true) return true
    else if (conditions === false) return false
    else if (!conditions) return emptyReturn

    return (conditions as { or: ConditionBlock[] }).or.reduce(
        (result: boolean, blockExp: ConditionBlock) =>
            result || blockExp.and.reduce((result: boolean, exp: Expression) => result && checkExpression(instance, exp, { $value }), true),
        false
    )
}

/**
 * Distingue o tri-estado: true/false são booleanos, mas o mesmo campo pode guardar
 * `{or: [{and: [...]}]}`. Quem só sabe editar booleano precisa reconhecer o caso
 * para não substituí-lo.
 */
export function isCondition(value: any): boolean {
    return !!value && typeof value === 'object' && Array.isArray((value as any).or)
}

export function writeConditions(conditions: { or: ConditionBlock[] }): string {
    const and = ` ${t('condition.and')} `
    const or = `) ${t('condition.or')} (`
    return conditions.or.map(c => c.and.map(exp => writeExp(exp)).join(and)).join(or)
}

function writeExp(exp: Expression): string {
    //operatorLabel e não exp.operator: o operador gravado é identificador em inglês
    const operator = operatorLabel(exp.operator)
    if (exp.targetProperty || exp.targetValue) return `${exp.property} ${operator} ${exp.targetProperty || exp.targetValue}`
    else return `${exp.property} ${operator}`
}
